import isEmpty from 'lodash/isEmpty';

import { RootState } from '../../types';

export const current = (state: RootState) => state.app.lang;
export const ready = (state: RootState) => !isEmpty(state.app.lang);
